import { ExecutiveKpi } from './dashboard.types';

type ExecutiveKpiCardProps = {
  item: ExecutiveKpi;
};

export const ExecutiveKpiCard = ({ item }: ExecutiveKpiCardProps) => (
  <article
    className={`arx-executive-kpi arx-executive-kpi--${item.tone}`}
    data-aranox-dashboard-kpi={item.id}
  >
    <div className="arx-executive-kpi__header">
      <span className="arx-executive-kpi__label">{item.label}</span>
      <span className="arx-executive-kpi__signal" aria-hidden="true" />
    </div>
    <strong className="arx-executive-kpi__value">{item.value}</strong>
    <p>{item.detail}</p>
    <span className="arx-executive-kpi__trend">{item.trend}</span>
  </article>
);
